export const customMessages = {
  'idAgrotoxico': {
    'number.base': '(Agrotóxico) deve ser informado.',
    'number.empty': '(Agrotóxico) deve ser informado.',
    'number.integer': '(Agrotóxico) deve ser informado.',
    'any.required': '(Agrotóxico) deve ser informado.'
  },
  'idResponsavel': {
    'string.base': '(Responsável técnico) deve ser informado.',
    'string.empty': '(Responsável técnico) deve ser informado.',
    'string.guid': '(Responsável técnico) deve ser informado.',
    'any.required': '(Responsável técnico) deve ser informado.',
  },
  'idFornecedor': {
    'string.base': '(Fornecedor) deve ser informado.',
    'string.empty': '(Fornecedor) deve ser informado.',
    'string.guid': '(Fornecedor) deve ser informado.',
    'any.required': '(Fornecedor) deve ser informado.',
  },
  'naturezaOperacao': {
    'string.empty': '(Natureza operação) é um campo obrigatório',
    'string.max': '(Natureza operação) deve ter no máximo 255 caracteres',
    'any.required': '(Natureza operação) é um campo obrigatório',
  },
  'quantidade': {
    'number.base': '(Quantidade) deve ser preenchida.',
    'number.empty': '(Quantidade) deve ser preenchida.',
    'number.integer': '(Quantidade) deve ser preenchida.',
    'any.required': '(Quantidade) deve ser preenchida.'
  },
  'idEmbalagem': {
    'number.base': '(Embalagem) deve ser preenchida.',
    'number.empty': '(Embalagem) deve ser preenchida.',
    'number.integer': '(Embalagem) deve ser preenchida.',
    'any.required': '(Embalagem) deve ser preenchida.',
  },
  'embalagem': {
    'string.base': '(Embalagem) deve ser preenchida.',
    'string.empty': '(Embalagem) deve ser preenchida.',
    'any.required': '(Embalagem) deve ser preenchida.',
  },
  'data': {
    'date.base': '(Data) deve ser uma data válida'
  },
  'dataNfe': {
    'date.base': '(Data NF-e) deve ser uma data válida'
  },
  'destinoProduto': {
    'string.base': '(Cidade) deve ser um texto',
    'string.empty': '(Cidade) deve ser um texto',
    'string.min': '(Cidade) deve ter no mínimo 3 caracteres',
    'string.max': '(Cidade) deve ter no máximo 100 caracteres',
    'any.required': '(Cidade) é um campo obrigatório',
  },
  'tipo': {
    "any.required": "(Tipo) é obrigatório.",
    "string.base": "(Tipo) é obrigatório.",
    "string.empty": "(Tipo) não pode estar vazio.",
    "any.only": "(Tipo) informado incorreto."
  },
  'numeroNfe': {
    'number.base': '(Nº NF-e) deve ser preenchido.',
    'number.empty': '(Nº NF-e) deve ser preenchido.',
    'number.integer': '(Nº NF-e) deve ser preenchido.',
    'any.required': '(Nº NF-e) deve ser preenchido.'
  },
  'serieNfe': {
    'number.base': '(Serie NF-e) deve ser preenchida.',
    'number.empty': '(Serie NF-e) deve ser preenchida.',
    'number.integer': '(Serie NF-e) deve ser preenchida.',
    'any.required': '(Serie NF-e) deve ser preenchida.'
  },
};